'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WishConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WishConstants = exports.WishConstants = (0, _keymirror2.default)({
    ADD_TO_WISHLIST: null,
    DEL_FROM_WISHLIST: null,
    COPY_TO_WISHLIST: null,
    COPY_TO_WISHLIST_AUTHUSER: null,
    UPDATE_PRODUCT_FOR_WISHLIST: null,
    GET_ACTUAL_PRICES_FAIL_WISHLIST: null,
    GET_ACTUAL_PRICES_SUCCESS_WISHLIST: null,
    GET_ACTUAL_PRICES_LOAD_WISHLIST: null,
    SET_WISHLIST: null,
    SET_WISHLIST_FAIL: null,
    SET_WISHLIST_SUCCESS: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/wish_list.js
// module id = 1884
// module chunks = 0